<app-kontable
        [source]="entities"
        [title]="'common.entity_title' | translate"
        [columns]="['id', 'name', 'description']"
        [titles]="['common.id', 'common.name', 'common.description']"
        [showInfoButton]="false"
        [showGlobalFilter]="false"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onAdd)="showAddOrEditDialog(null)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)"
>
</app-kontable>

<p-dialog
        *ngIf="show.modal"
        [(visible)]="show.modal"
        [modal]="true"
        header="{{modalTitle}}"
        [resizable]="false"
        [draggable]="true"
        [positionTop]="50"
        [width]="500"
        (onHide)="closeAddDialog()">
    <app-entity-form
            (onAddElement)="onAddElement($event)"
            (onUpdateElement)="onUpdateElement($event)"
            [editingElement]="selectedEntity"
    ></app-entity-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/entity/entity.component.html